import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { SUPPORTED_LANGUAGES } from "@/lib/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguagePicker({ variant = "default" }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.split("-")[0] || "pt";
  const currentLang = SUPPORTED_LANGUAGES.find((l) => l.code === current) || SUPPORTED_LANGUAGES[0];

  const handleChange = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem("mounjaro_language", code);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-picker-trigger"
          className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg hover:bg-secondary/60 transition-colors text-sm"
          aria-label="Change language"
        >
          <span className="text-base leading-none">{currentLang.flag}</span>
          <span className="text-xs font-medium text-muted-foreground uppercase">{currentLang.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-card border-border">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => handleChange(lang.code)}
            data-testid={`language-picker-${lang.code}`}
            className={`gap-3 cursor-pointer ${current === lang.code ? "bg-primary/10 text-primary" : ""}`}
          >
            <span className="text-lg">{lang.flag}</span>
            <span className="flex-1">{lang.nativeName}</span>
            {current === lang.code && <span className="text-primary">✓</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
